import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../util/axiosConfig";
import { useAuth } from "../../global/AuthContext";
import BoardDetail, { BoardPost } from "../../component/board/BoardDetail";


export default function ViewNotice() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { user } = useAuth();
	const [error, setError] = useState("");
	const [notice, setNotice] = useState<BoardPost | null>(null);

	useEffect(() => {
		let active = true;
		setNotice(null);
		setError("");
		axios
			.get<BoardPost>(`/api/notices/${id}`)
			.then((res) => { if (active) setNotice(res.data); })
			.catch(() => { if (active) setError("공지사항을 불러오지 못했습니다."); });
		return () => { active = false; };
	}, [id]);

	if (!notice) return <div className="BoardDetail"><p role={error ? "alert" : "status"}>{error || "로딩중..."}</p><button onClick={() => navigate("/notices")}>목록</button></div>;

	const handleDelete = async () => {
		if (!window.confirm("정말 삭제하시겠습니까?")) return;

		try {
			await axios.delete(`/api/notices/${id}`);
			alert("삭제되었습니다.");
			navigate("/notices"); // ✅ 삭제 후 목록으로 이동
		} catch (err) {
			console.error(err);
			alert("삭제 중 오류 발생");
		}
	};

	return <BoardDetail post={notice} actions={<>
        <button onClick={() => navigate("/notices")}>목록</button>
        {user?.role === "admin" && <>
            <button onClick={() => navigate(`/notices/update/${notice.id}`)}>수정</button>
            <button onClick={handleDelete}>삭제</button>
        </>}
    </>}/>;
}
